export const DASHBOARD_ACCESS = "https://claims.labelinsights.com/dashboard";
export const ParagraphsPageSize = 10;
export const ClustersPageSize = 15;
